<template>
  <div class="contact">
    <div class="container">
      <div class="contact__wrapper">
        <h2 class="contact__title">{{ t('contact.title') }}</h2>
        <div class="contact__form">
          <div class="contact__form-box">
            <ui-input
              :type="'text'"
              :placeholder="t('fields.name')"
              :rules="[required]"
              v-model="name"
            />
            <ui-input
              :type="'text'"
              :placeholder="t('fields.topic')"
              :rules="[required]"
              v-model="topic"
            />
          </div>
          <div class="contact__form-box">
            <ui-input
              :type="'email'"
              :placeholder="t('fields.email')"
              :rules="[isEmail]"
              v-model="email"
            />
            <ui-input
              :type="'text'"
              :placeholder="t('fields.email')"
              :rules="[required]"
              v-model="phone"
            />
          </div>
          <ui-textarea
            :placeholder="t('fields.inquiry')"
            :rules="[required]"
            v-model="inquiry"
          />
          <ui-button
            :isDisabled="!isFormValid"
            :isLoading="isLoading"
          >
            {{ t('buttons.contact') }}
          </ui-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiInput from "@/components/ui/ui-input.vue";
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiTextarea from "@/components/ui/ui-textarea.vue";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n()

const name = ref('')
const topic = ref('')
const email = ref('')
const phone = ref('')
const inquiry = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    required(name.value) === true &&
    required(topic.value) === true &&
    required(phone.value) === true &&
    required(inquiry.value) === true
  )
})
</script>

<style lang="scss" scoped>
.contact {
  padding-block: 75px 100px;

  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }

  &__title {
    color: #173760;
    font-size: 60px;
    font-weight: 600;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 35px;

    &-box {
      display: flex;
      align-items: center;
      gap: 35px;
    }
  }
}
</style>